/* eslint-disable require-jsdoc */
(function() {
	'use strict';
	var $ = avm.require('jquery'),
		$filterTrigger = $('.js-filter-trigger'),
		$tiles = $('.js-product-box'),
		$titles = $('.js-title-filter'),
		state = {
			name: 'all-products',
			platform: 'all-platforms',
			category: 'all-categories'
		};

	$('.overlay-box-trigger').on('click', function() {
		$('.popup').hide();
		if ($(this).hasClass('overlay-ise')) {
			$('.overlay-box-container .popup-ise').toggle('active');

		} else if ($(this).hasClass('overlay-secure-vpn')) {
			$('.overlay-box-container .popup-secure-vpn').toggle('active');
		} else if ($(this).hasClass('overlay-tuneup')) {
			$('.overlay-box-container .popup-tuneup').toggle('active');
		} else if ($(this).hasClass('overlay-ultimate')) {
			$('.overlay-box-container .popup-ultimate').toggle('active');
		} else if ($(this).hasClass('overlay-driver-updater')) {
			$('.overlay-box-container .popup-driver-updater').toggle('active');
		} else if ($(this).hasClass('overlay-antitrack')) {
			$('.overlay-box-container .popup-antitrack').toggle('active');
		} else if ($(this).hasClass('overlay-business')) {
			$('.overlay-box-container .popup-business').toggle('active');
		} else if ($(this).hasClass('overlay-file-server')) {
			$('.overlay-box-container .popup-file-server').toggle('active');
		} else if ($(this).hasClass('overlay-isb')) {
			$('.overlay-box-container .popup-isb').toggle('active');
		}

		$('.overlay').addClass('active');
		$('html, body').css('overflowY', 'hidden');

	});
	$('.overlay-box-close, [data-behavior="popup-close"]').on('click', function(e) {
		// $body.off('mousewheel');
		if (e.target !== this) {
			return;
		}
		$('.overlay').removeClass('active');
		$('html, body').css('overflowY', 'auto');
	});

	filter();

	$filterTrigger.change(function() {
		var $self = $(this),
			selfType = $self.data('type').substring(8),
			selectedOption = $self.find(':selected').data('option');

		state[selfType] = selectedOption;
		filter();
	});

	function filter() {
		filterTiles();
	}

	function filterTiles() {
		var result = [];
		$tiles.each(function() {
			var $self = $(this),
				selfData = $self.data(),
				selfDataObject = {
					name: selfData.productName.split(' '),
					platform: selfData.productPlatform.split(' '),
					category: selfData.productCategory.split(' ')
				};

			if (selfDataObject.name.indexOf(state.name) > -1 &&
				selfDataObject.platform.indexOf(state.platform) > -1 &&
				selfDataObject.category.indexOf(state.category) > -1
			) {
				$self.addClass('active');

				// Read data on tile and push only specific category to result
				var arr = $self.data('product-name').split(' '),
					index = arr.indexOf('all-products');

				if (index > -1) {
					arr.splice(index, 1);
				}

				// Prevent duplicates to be pushed
				if (result.indexOf(arr[0]) === -1) {
					result.push(arr[0]);
				}
			} else {
				$self.removeClass('active');
			}
		});

		filterTitles(result);
	}

	function filterTitles(categories) {
		$titles.each(function() {
			var $self = $(this),
				selfDataName = $self.data('product-name');

			if (categories.indexOf(selfDataName) > -1) {
				$self.addClass('active');
			} else {
				$self.removeClass('active');
			}

			if (categories.length === 0) {
				$('.no-products').show();
			} else {
				$('.no-products').hide();
			}
		});
	}

})();

/* Tabs-anchor */
(function() {
	'use strict';
	
	$(".all-products").click(function(){
		$(".all-products").addClass("active");
		$(".home").removeClass("active");
		$(".business").removeClass("active");		
		$("#home").show();
		$("#business").show();		
	});
	$(".home").click(function(){
		$(".all-products").removeClass("active");
		$(".home").addClass("active");	
		$(".business").removeClass("active");
		$("#business").hide();
		$("#home").show();
	});	
	$(".business").click(function(){
		$(".all-products").removeClass("active");	
		$(".business").addClass("active");	
		$(".home").removeClass("active");
		$("#home").hide();
		$("#business").show();
	});
	$('.tooltip').each(function() {
		var iconPos = $(this).closest('p').find('.ico.info').position();
		$(this).css('margin-top', -($(this).innerHeight() - 5));
		$(this).css('margin-left', -134 + iconPos.left);
	});
})();
